import React, { useState, useEffect } from 'react'
import { ReactComponent as HelpIcon } from '../assets/svg/help.svg'
import axios from 'axios'
import { encrypt } from '../utils/encrypt-decrypt'
import { useSelector } from 'react-redux'

const ExplainTerm = ({ term, calculatorName }) => {
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const [explanation, setExplanation] = useState('')
    const { language, currency } = useSelector((state) => state.settings)
    const { activeTab } = useSelector((state) => state.aiAnalysis);
    const gstVatTabs = {
        "GSTCalc": "gstCalculator",
        "VatCalc": "vatCalculator",
    }
    useEffect(() => {
        if (isModalOpen) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = 'auto'
        }

        return () => {
            document.body.style.overflow = 'auto'
        }
    }, [isModalOpen])

    const getTermDescription = async () => {
        try {
            setLoading(true)
            const payload = {
                selected_term: term,
                calculator_type: calculatorName === "sip-investment-calculator" ? activeTab === "sip" ? "sip/ swp investment calculator" : "lumpsum investment calculator" : calculatorName === "gst-tax-calculator" ? gstVatTabs[activeTab] : calculatorName,
                language: language.value,
                currency: currency.value,
            }
            const encryptedData = encrypt({
                params: payload,
                iv_key: process.env.REACT_APP_GROWLIFE_CRYPTO_IV_KEY,
                secret_key: process.env.REACT_APP_GROWLIFE_CRYPTO_SECRET_KEY,
            }, process.env.REACT_APP_GROWLIFE_CRYPTO_SECRET_KEY, process.env.REACT_APP_GROWLIFE_CRYPTO_IV, process.env.REACT_APP_GROWLIFE_CRYPTO_ALGORITHM)

            const response = await axios.post(process.env.REACT_APP_AI_BASE_URL + '/explain-term', {
                type: "GROWLIFE",
                token: encryptedData
            })

            if (response.data?.status && response.data?.data?.explanation) {
                setExplanation(response.data.data.explanation)
            }
        } catch (error) {
            console.log(error)
            setExplanation('Unable to load explanation. Please try again.')
        } finally {
            setLoading(false)
        }
    }

    const handleOpen = () => {
        setIsModalOpen(true)
        setExplanation('')
        getTermDescription()
    }

    const handleClose = () => {
        setIsModalOpen(false)
        setExplanation('')
    }

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            handleClose()
        }
    }

    return (
        <>
            <div onClick={handleOpen} className="cursor-pointer inline-flex">
                <HelpIcon />
            </div>

            {/* Modal */}
            {isModalOpen && (
                <div
                    className="fixed inset-0 bg-black/30 backdrop-blur-sm flex justify-center items-center z-50"
                    onClick={handleBackdropClick}
                >
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-[95%] sm:max-w-[500px] max-h-[90vh] overflow-y-auto relative animate-fadeIn flex flex-col gap-3">
                        {/* Header */}
                        <div className="flex items-center justify-between border-b border-b-[#DDE1E5] p-6 pb-3">
                            <h2 className="text-base text-[#282828] font-lato-semibold-600 capitalize">
                                {term}
                            </h2>
                            <button
                                onClick={handleClose}
                                className="w-8 h-8 bg-[#DDE1E5] flex items-center justify-center rounded-full hover:bg-gray-300 transition-colors"
                            >
                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                                    <path d="M1 1L9 9M1 9L9 1" stroke="#282828" strokeWidth="2" strokeLinecap="round" />
                                </svg>
                            </button>
                        </div>

                        {/* Content */}
                        <div className="p-6 pt-0 min-h-[150px]">
                            {loading ? (
                                /* Loading State */
                                <div className="flex items-center justify-center py-12">
                                    <div className="text-center">
                                        {/* Gradient Rounded Spinner */}
                                        <div className="inline-block relative w-12 h-12">
                                            <div
                                                className="w-12 h-12 rounded-full animate-spin"
                                                style={{
                                                    background: 'linear-gradient(88.83deg, #E56489 -2.77%, #AE1595 30.94%, #5230EE 64.9%, #6B55F0 92.76%)',
                                                    mask: 'radial-gradient(farthest-side, transparent calc(100% - 4px), #000 calc(100% - 3px))',
                                                    WebkitMask: 'radial-gradient(farthest-side, transparent calc(100% - 4px), #000 calc(100% - 3px))'
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                /* Explanation Content */
                                <div className="bg-[#F6F8FB] rounded-xl py-4 px-3">
                                    <div className="text-[#282828] text-sm text-start font-lato-regular-400 leading-relaxed" dangerouslySetInnerHTML={{ __html: explanation || 'No explanation available.' }} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default ExplainTerm
